import React, {Component} from 'react';

export default class LoadingSpinner extends Component {
    render() {
        return <i className="fa fa-fw fa-spin fa-spinner"></i>;
    }
}